import { Flex, Tag } from "antd"
import { FC } from "react"

interface ITitleCustomerCard {
  fullName: string
  roles: [string]
}

const TitleCustomerCard: FC<ITitleCustomerCard> = ({ fullName, roles }) => {
  return (
    <Flex justify="space-between" align="center">
      {fullName}
      {roles.map((role) => (
        <Tag key={role} color="purple">
          {role}
        </Tag>
      ))}
    </Flex>
  )
}

export default TitleCustomerCard
